export default "<img [src]=\"imgUrl\" [ngClass]=\"imgClass\" class=\"{{stylingClass}}\">\n"